import { Card, CardContent } from '@g17eco/ui-modern/components/ui/card';
import { type FormData } from './types';
import { ActivityFields, type ActivityFieldValues } from './ActivityFields';

interface DetailsStepProps {
  formData: FormData;
  updateField: <K extends keyof FormData>(field: K, value: FormData[K]) => void;
}

export const DetailsStep = ({ formData, updateField }: DetailsStepProps) => {
  const values: ActivityFieldValues = {
    scope: formData.scope,
    activityType: formData.activityType,
    periodStart: formData.periodStart,
    periodEnd: formData.periodEnd,
    quantity: formData.quantity,
    unit: formData.unit,
    fuelType: formData.fuelType,
    vehicleType: formData.vehicleType,
    refrigerantType: formData.refrigerantType,
    processType: formData.processType,
    region: formData.region,
    regionFallback: formData.regionFallback,
    yearFallback: formData.yearFallback,
    name: formData.name,
    dataSource: formData.dataSource,
    notes: formData.notes,
  };

  const handleUpdate = (updates: Partial<ActivityFieldValues>) => {
    for (const [key, value] of Object.entries(updates)) {
      updateField(key as keyof FormData, value as FormData[keyof FormData]);
    }
  };

  return (
    <Card className='tw:mb-6'>
      <CardContent className='tw:p-6'>
        <h5 className='tw:font-semibold tw:mb-5'>Activity Details</h5>
        <ActivityFields values={values} onUpdate={handleUpdate} />
      </CardContent>
    </Card>
  );
};
